import React, { ReactNode } from "react";
import { cn } from "~/utils/fontsConfig";
import { If } from "../v3/Conditional";
import Linkify from "linkify-react";
import { AiOutlineExclamationCircle } from "react-icons/ai";
import { RiErrorWarningLine } from "react-icons/ri";

type Props = {
    title: string;
    message: string;
    tooltip?: ReactNode;
    linkText?: string;
    onLinkClick?: () => void;
    className?: React.ComponentProps<"div">["className"];
    footer?: ReactNode;
};

export const SystemMessage = ({
    title,
    message,
    tooltip,
    linkText,
    onLinkClick,
    className,
    footer,
}: Props) => {
    const messageWithLineBreaks = message
        .split("\n")
        .map((line, index, array) => (
            <React.Fragment key={index}>
                {line}
                {index < array.length - 1 && index > 0 && <br />}{" "}
                {/* Add <br /> after every line except the last and the first*/}
            </React.Fragment>
        ));

    return (
        <div
            className={cn(
                "inline-flex w-full items-start justify-start gap-4 rounded-xl border border-[#d9f1d92f] bg-[#362e15] px-4 py-3",
                className,
            )}
        >
            <div className="flex h-full items-start justify-center">
                <div className="rounded bg-[#594911] p-1">
                    <RiErrorWarningLine className="h-4 w-4 text-[#FFC700]" />
                </div>
            </div>
            <div className="flex w-full items-center justify-start gap-4">
                <div className="inline-flex w-full flex-col items-start justify-center gap-3">
                    <div className="flex w-full flex-row text-sm font-semibold leading-4 tracking-wider text-[#FFE999]">
                        <div className="grow">{title}</div>
                        <If condition={!!tooltip}>
                            <div className="font-light">{tooltip}</div>
                        </If>
                    </div>
                    <div className="text-sm font-normal tracking-wider text-[#FFE999]">
                        <Linkify options={{ className: "break-all" }}>
                            {messageWithLineBreaks}
                        </Linkify>
                    </div>
                    {linkText && (
                        <div className="inline-flex items-center justify-start gap-2">
                            <button
                                onClick={onLinkClick}
                                className="text-xs font-medium leading-4 tracking-wider text-white underline"
                            >
                                {linkText}
                            </button>
                        </div>
                    )}
                    {footer}
                </div>
            </div>
        </div>
    );
};

export default SystemMessage;
